import React, { useState, useEffect, createContext, useContext } from "react";
import { useAuth } from "../../hooks";
import { getAllUsers } from "../../GeneralAdmin/modules/GAUsers/hooks/GAUsersHooks";
import { getMostRecentUserContentReport } from "../../GeneralAdmin/modules/GAContentModeration/hooks/ContentReportsHooks";

export const UsersContext = createContext();
export const useUsersContext = () => useContext(UsersContext);

export const UsersProvider = ({ children }) => {
  const { currentUser, organizationId } = useAuth();
  const [loading, setLoading] = useState(false);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(200);

  //general admin states
  const [GAUsers, setGAUsers] = useState([]);
  //general admin states

  //general admin section functions
  const handleGetAllGAUsers = async () => {
    try {
      setLoading(true);

      // Fetch all users
      const querySnapshot = await getAllUsers();

      // Map over each user to fetch their most recent content report
      const usersPromises = querySnapshot.docs.map(async (item) => {
        try {
          // Get the most recent report for the user
          let userReportsTemp = await getMostRecentUserContentReport(item.id);
          let statusTemp = "";

          // Extract the status from the report, if it exists
          userReportsTemp.forEach((doc) => {
            statusTemp = doc?.status?.status;
          });

          // Return user data with the most recent report status
          if (
            item.data().firstName === "Anonymous" ||
            item.data().firstName === "Guest"
          ) {
            // Skip the user if the first name is "Anonymous"
            return null;
          } else {
            return {
              ...item.data(),
              id: item.id,
              reportedStatus: statusTemp,
            };
          }
        } catch (error) {
          console.error(
            `Error fetching report for user ${item.id}:`,
            error.message
          );
          // Return user data with an error indication in status if the fetch fails
          return {
            ...item.data(),
            id: item.id,
            reportedStatus: "Error fetching report",
          };
        }
      });

      // Resolve all promises, filter out null values and update state
      let filteredUsers = (await Promise.all(usersPromises)).filter(
        (user) => user !== null
      );

      // Filter out "Guest User" entries (first name + last name combined)
      filteredUsers = filteredUsers.filter(user => {
        const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
        return fullName !== "Guest User";
      });

      // Sort alphabetically by full name (case-insensitive)
      filteredUsers.sort((a, b) => {
        const nameA = `${a.firstName || ''} ${a.lastName || ''}`.toLowerCase().trim();
        const nameB = `${b.firstName || ''} ${b.lastName || ''}`.toLowerCase().trim();
        return nameA.localeCompare(nameB);
      });

      console.log("GA users data:", filteredUsers);
      setGAUsers(filteredUsers);
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGetAllGAUsersWithAnonymous = async () => {
    try {
      setLoading(true);

      // Fetch all users
      const querySnapshot = await getAllUsers();

      // Map over each user to fetch their most recent content report
      const usersPromises = querySnapshot.docs.map(async (item) => {
        try {
          // Get the most recent report for the user
          let userReportsTemp = await getMostRecentUserContentReport(item.id);
          // console.log(userReportsTemp);
          let statusTemp = "";

          // Extract the status from the report, if it exists
          userReportsTemp.forEach((doc) => {
            console.log("report::", doc);
            statusTemp = doc?.status?.status;
          });

          return {
            ...item.data(),
            id: item.id,
            reportedStatus: statusTemp,
          };
          // }
        } catch (error) {
          console.error(
            `Error fetching report for user ${item.id}:`,
            error.message
          );
          // Return user data with an error indication in status if the fetch fails
          return {
            ...item.data(),
            id: item.id,
            reportedStatus: "Error fetching report",
          };
        }
      });

      // Resolve all promises and update state
      const temp = await Promise.all(usersPromises);
      console.log("GA users data:", temp);
      setGAUsers(temp);
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
    } finally {
      setLoading(false);
    }
  };

  // const handleGetAllGAUsers = async () => {
  //   try {
  //     setLoading(true);
  //     // let temp = [];
  //     // const querySnapshot = await getAllUsers();
  //     // querySnapshot.docs.forEach(async (item) => {
  //     //   let userReportsTemp = await getMostRecentUserContentReport(item.id)
  //     //   let statusTemp= ""
  //     //   userReportsTemp.forEach(doc=>{
  //     //   statusTemp = doc.status.status
  //     //   })
  //     //   temp.push({
  //     //     ...item.data(),
  //     //     id: item.id,
  //     //     // reportedStatus: userReportsTemp
  //     //     reportedStatus: statusTemp
  //     //   });
  //     // });
  //     // console.log("GA users data:", temp);
  //     // setGAUsers(temp);

  //     const querySnapshot = await getAllUsers();
  //     const usersPromises = querySnapshot.docs.map(async (item) => {
  //       let userReportsTemp = await getMostRecentUserContentReport(item.id);
  //       let statusTemp = "";
  //       userReportsTemp.forEach((doc) => {
  //         statusTemp = doc.status.status;
  //       });
  //       return {
  //         ...item.data(),
  //         id: item.id,
  //         // reportedStatus: userReportsTemp
  //         reportedStatus: statusTemp,
  //       };
  //     });

  //     const temp = await Promise.all(usersPromises);
  //     console.log("GA users data:", temp);
  //     setGAUsers(temp);
  //   } catch (error) {
  //     console.error("Error fetching data from Firestore:", error.message);
  //     setLoading(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //general admin section functions

  return (
    <UsersContext.Provider
      value={{
        loading,
        setLoading,
        //general admin section
        GAUsers,
        setGAUsers,
        handleGetAllGAUsers,
        handleGetAllGAUsersWithAnonymous,
        //general admin section
        order,
        setOrder,
        orderBy,
        setOrderBy,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
};
